
export const WC_PROJECT_ID = 'e24844c5deb5193c1c14840a7af6a40b';

export const LEDGER_WALLET_API_KEY = import.meta.env.REACT_APP_LEDGER_WALLET_API_KEY;
export const LEDGER_WALLET_IDENTIFIER = import.meta.env.REACT_APP_LEDGER_WALLET_IDENTIFIER;

export const hasLedgerWalletCredentials = !!LEDGER_WALLET_API_KEY && !!LEDGER_WALLET_IDENTIFIER;
